import React from 'react'

import InviteSelect from 'components/shared/InviteSelect'

import PlaybookModal from '../PlaybookModal'

import './style.styl'

const SequenceInviteModal = ({ users, options, onNext, onCloseClick }) => (
  <PlaybookModal
    hideDescription
    title="Share Sequence"
    isOpen
    contentClassName="playbook-sequence-invite-modal"
    onCloseClick={onCloseClick}
  >
    <InviteSelect
      users={users}
      options={options}
      CTA="Share"
      onNext={onNext}
    />
  </PlaybookModal>
)

export default SequenceInviteModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SequenceInviteModal/component.js